export class Users {
  adminId?: string;
  firstName?: string;
  lastName?: string;
  userName?: string;
  passwd?: string;
  publicKey?: string;
  emailId?: string;
  contactNo?: string;
  userRole?: string;
  storageInGb?: string;
  depName?: string;
  jobSubmitId?: string;
  walletAmount?: number;
  allocatedCoreQuota?: number;
  userDetails?: UserDetails2[];
  attachedGroup?: string;
  userStartCommand?: string;
  mappedWorkstation?: string;
  perSessionMaxTime?: number;
  createTime?: string;
  lastLoginTime?: string;
  weeekDaySequence?: string;
  batchStartDate?: string;
  batchEndDate?: string;
  batchStartTime?: string;
  batchEndTime?: string;
  userInBatch?: string;
  sessionWalletBalance?: number;
  additionalInfo?: string;
  anywareGuid?: string;
  anywareUpn?: string;
  showBilling?: boolean;
  addUserCustomUid?: string;
  addUserCustomGid?: string;
  addUserToIdentityServer?: boolean;
  addUserToCluster?: boolean;
  userIdForIdentityServer?: string;
  sessionUserId?: string;
}

export class AddUserDTO {
  constructor(
    public firstName: string = "",
    public lastName: string = "",
    public userName: string = "",
    public emailId: string = "",
    public password: string = "",
    public deployment: string = "",
    public userRole: string = "", // workkk on these pending
    public publicKey: string = ""
  ) { }
}

export interface UserDetails2 {
  deploymentName: string;
  userRole: string;
  nodeGroup: string;
  mappedWorkstation: string;
}

export interface UserDetails {
  deploymentName: string;
  userRole: string;
  nodeGroup: string;
  jobPriority?: string;
  profileCoreQuota?: number;
  toShowActions?: boolean;
  session?: string[];
  jobPath?: Number;
  jobSubmitId?: string;
  mappedWorkstation: string;
  userAppDetails?: UserAppDetails;
  sessionUserId?: string;
  isVdi?: boolean;
  isGroupAttached: boolean;
  maxJobs: number;
  maxSubmitJobs: number;
  assignedStorages?: string[];
}
export interface UserProfileResponse {
  userDetails: UserDetails;
  jobsLimits: JobLimits;
}
export interface JobLimits {
  maxJobs: number,
  maxSubmitJobs: number
}
export interface UserJobPath {
  jobPath: string;
  jobValue: Number;
}
export interface UserJobPathData {
  deploymentName: string;
  deploymentData: UserJobPath;
  jobPathOptions: UserJobPath[];
}

export const UserRoleNames = {
  GlobalAdmin: "Global Admin",
  DeploymentAdmin: "Deployment Admin",
  PowerUser: "Power User",
  JobOperator: "Job Operator",
  Info_GlobalAdmin: "Global Access",
  Info_DeploymentAdmin: "Can Delete, Scale, Power On/Off, Connect, Submit Jobs",
  Info_PowerUser: "Can Scale, Power On/Off, Connect, Submit Jobs",
  Info_JobOperator: "Can Submit Jobs and Connect",
  Reader: "Reader",
};

export enum UserRolesInt {
  GlobalAdmin = 0, //All Access
  DeploymentAdmin, // Delete + Scale Up/Down +  Connect + Power On/Off + Job Submit
  PowerUser, //Scale Up/Down +  Connect + Power On/Off + Job Submit
  JobOperator, //Only Job Submit
  Reader,
}

export interface UserAppDetails {
  deploymentAppList: DepAppListObj[];
  userAllowedApps: string;
  userAllowedAppLicenses: string | null;
}

export interface UserGroups {
  name: string;
  createdOn: Date;
  lastModified: Date;
  users: string | null;
  createdBy: string;
  tags: string | null;
  policy: string | null;
  groupsProfileInfo?: UserDetails[] | null;
}

export interface DepAppListObj {
  uniqueId: string;
  appName: string;
  appVersion: string;
  avlLicenses: string[];
}
